import { render, staticRenderFns } from "./Authenticated.vue?vue&type=template&id=fa204546&scoped=true&"
import script from "./Authenticated.vue?vue&type=script&lang=ts&"
export * from "./Authenticated.vue?vue&type=script&lang=ts&"
import style0 from "./Authenticated.vue?vue&type=style&index=0&id=fa204546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa204546",
  null
  
)

export default component.exports